import { render, staticRenderFns } from "./MediaLibraryNewFolder.vue?vue&type=template&id=4d4c4692&scoped=true&"
import script from "./MediaLibraryNewFolder.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryNewFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c4692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4c4692')) {
      api.createRecord('4d4c4692', component.options)
    } else {
      api.reload('4d4c4692', component.options)
    }
    module.hot.accept("./MediaLibraryNewFolder.vue?vue&type=template&id=4d4c4692&scoped=true&", function () {
      api.rerender('4d4c4692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/MediaLibraryNewFolder.vue"
export default component.exports